import { useEffect, useRef } from 'react';

type MountCallback = () => void;

export const useOnMount = (callback: MountCallback) => {
    const mountCallbackRef = useRef<MountCallback>(callback);

    useEffect(() => {
        mountCallbackRef.current();
    }, []);
};
